import { AxfoodMergeCartViewModel, TimeSlotData } from '@occ/api-client';
import usePersistedCart from '@hooks/usePersistedCart';
import useCart from '@hooks/useCart';

/**
 * Whether the session cart has anything worth keeping (items or a selected slot).
 */
export const hasSessionCart = (isCartEmpty: boolean, cartSlot: TimeSlotData | null | undefined): boolean =>
  !isCartEmpty || cartSlot !== null;

/**
 * Checks if the merge cart modal should be shown based on cart state.
 * Used by useMergeCartModalWillShow hook and can be called directly when
 * you have the values from a non-hook context (e.g., after trigger() call).
 */
export const shouldShowMergeCartModal = (
  persistedCart: AxfoodMergeCartViewModel | undefined,
  isCartEmpty: boolean,
  cartSlot: TimeSlotData | null | undefined
): boolean => (persistedCart?.totalPersistedCartProducts ?? 0) > 0 && hasSessionCart(isCartEmpty, cartSlot);

/**
 * Returns whether the merge cart modal will be shown.
 * This happens when the user has both a session cart (with items or a slot)
 * and a persisted cart from a previous session.
 */
const useMergeCartModalWillShow = () => {
  const { persistedCart } = usePersistedCart();
  const { cart, isCartEmpty } = useCart();

  return shouldShowMergeCartModal(persistedCart, isCartEmpty, cart?.slot);
};

export default useMergeCartModalWillShow;
